<template>
  <div
    class="cursor-pointer rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition"
    @click="$emit('click')"
  >
    <img
      :src="thumbnail"
      :alt="title"
      class="w-full h-48 object-cover"
    />
    <div class="p-4 bg-white">
      <h3 class="text-xl font-bold mb-1">{{ title }}</h3>
      <p class="text-sm text-gray-600 mb-4">{{ description }}</p>

      <div class="flex gap-2 flex-wrap">
        <span
          v-for="(item, index) in tech"
          :key="index"
          class="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-full flex items-center gap-1"
        >
          <img
            v-if="icons[item]"
            :src="icons[item]"
            :alt="item"
            class="w-4 h-4"
          />
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: {
    title: String,
    description: String,
    thumbnail: String,
    tech: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      icons: {
        mql5: '/icons/mt5.svg',
        telegram: '/icons/telegram.svg',
        vue: '/icons/vue.svg',
        pine: '/icons/pinescript.svg',
        js: '/icons/js.svg',
        python: '/icons/python.svg'
      }
    }
  }
}
</script>
